import React, { useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import './kpiConfigAndPreview.css';
import '../../manageKPICommon.css'
import KPIConfigAndPreviewItem from "./kpiConfigAndPreviewItem/KPIConfigAndPreviewItem"
import { InputFieldLengthValidationType } from '../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKPIType';
import { Typography } from '@mui/material';

interface KPIConfigAndPreviewProps {
  selectedKPIsKeys: string[];
  setSelectedKPIsKeys: (keys: string[]) => void;
  userConfig : Record<string, any>[];
  updateUserConfig :(_id : string, _kpi :Record<string,any>)  => void;
  inputLengthValidation : InputFieldLengthValidationType;
  defaultConfigGlobal : Record<string,any>
}
const KPIConfigAndPreview: React.FC<KPIConfigAndPreviewProps> = ({
  selectedKPIsKeys,
  setSelectedKPIsKeys,
  userConfig ,
  updateUserConfig ,
  inputLengthValidation,
  defaultConfigGlobal 
}) => {
  const handleDragEnd = (result: any) => {
    if (!result.destination) return;

    const newOrder = Array.from(selectedKPIsKeys);
    const [movedItem] = newOrder.splice(result.source.index, 1);
    newOrder.splice(result.destination.index, 0, movedItem);

    setSelectedKPIsKeys(newOrder);
  };
  useEffect(()=>{
    const tempSetSelectedKPIsKey=selectedKPIsKeys.filter((item)=>userConfig.find((usr)=>usr.id===item))
    setSelectedKPIsKeys(tempSetSelectedKPIsKey)
  },[])

  return (
    <>
    <div style={{padding:"8px 8px 8px 10px", backgroundColor:"#f9fafc",}} >
  <Typography
          sx={{
            color: "black",
            fontSize: { xs: "1rem", md: "1rem", xl: "2rem" },
            fontWeight: "600",
      
          }}
        >
          KPIs
        </Typography>
        </div>
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="kpi-list-droppable" >
        {(provided) => (
          <div className="kpi-list gray-border round-border" {...provided.droppableProps} ref={provided.innerRef}>
            {selectedKPIsKeys.map((key, index) => (
              <Draggable key={key} draggableId={key} index={index}>
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="kpi-config-preview-item"
                  >
                    
                    <KPIConfigAndPreviewItem
                      kpi={userConfig.find((kpi)=>(kpi.id === key)) as Record<string,any>}
                      updateUserConfig = {updateUserConfig}
                      inputLengthValidation = {inputLengthValidation}
                      defaultConfigGlobal = {defaultConfigGlobal} 
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
    </>
  );
};


export default KPIConfigAndPreview;
